// extracted by mini-css-extract-plugin
export default {"shellDesktop":"profile_shellDesktop__R8wZU","shellMobile":"profile_shellMobile__AyiwC","profile":"profile_profile__bixlA","profileMobile":"profile_profileMobile__VAL5I"};